<template>
  <div class="manager_dashboard">
    <user-menu />
    <div class="wrapper">
      <manager-sidebar-menu :show_menu="true" :show_back_button="false" />
      <div class="content-wrapper" style="padding-left: 165px;">
        <div class="container-wrapper center">

          <div class="row">
            <div class="col-12 p-0 pl-2">
              <h3 class="heading text-uppercase mb-3">{{ accountName }}</h3>
            </div>
            <div class="col-7 pr-3 pr-xl-5">

              <div class="row justify-content-between custom-pl-15 pb-4" v-if="menteeCountLoading == true">
                <div class="col pl-0 pr-2" >
                  <PuSkeleton height="150px" :count="1"></PuSkeleton>
                </div>
                <div class="col pl-4" >
                  <PuSkeleton height="150px" :count="1"></PuSkeleton>
                </div>
                <div class="col pl-4 pr-1" >
                  <PuSkeleton height="150px" :count="1"></PuSkeleton>
                </div>
              </div>


              <div class="row justify-content-between custom-pl-15" v-if="menteeCountLoading == false">
                <div class="col pl-0 pr-xl-4 pr-lg-2" @click="adminPageRedirect()" style="cursor: pointer;">
                  <div class="shadow p-3 information_box">
                    <div class="information_box_title">Mentees</div>
                    <div class="h3">{{ menteeCount }}</div>

                    <span v-if="((previousYearMenteeCount > 0) && (previousYearMenteeCount < currentYearMenteeCount))" class="small px-2 py-1 information_box_text_up">
                      <img class="mr-1 stats_icon" src="@/assets/manager/up_tick_icon.png" />
                      Up {{ parseInt(currentYearMenteeCount - previousYearMenteeCount)}} this year</span>
                    <span v-else-if="((previousYearMenteeCount > 0) && (previousYearMenteeCount > currentYearMenteeCount))" class="small px-2 py-1 information_box_text_down">
                      <img class="mr-1 stats_icon" src="@/assets/manager/down_tick_icon.png" />
                      Down {{ parseInt(previousYearMenteeCount - currentYearMenteeCount)}} this year</span>
                    <span v-else class="small px-2 py-1">&nbsp;</span>
                    
                  </div>                  
                </div>
                <div class="col px-xl-4 px-lg-2" style="cursor: pointer;" @click="openAccountRepToReviewModal()">
                  <div class="shadow p-3 information_box">
                    <div class="information_box_title">Reps to Review</div>
                    <div class="h3">{{ repsReviewCount }}</div>

                    <span v-if="(previousWeekRepCount < currentWeekRepCount)" class="small px-2 py-1 information_box_text_up">
                      <img class="mr-1 stats_icon" src="@/assets/manager/up_tick_icon.png" />
                      Up {{ parseInt(currentWeekRepCount - previousWeekRepCount)}} this week</span>
                    <span v-else-if="(previousWeekRepCount > currentWeekRepCount)" class="small px-2 py-1 information_box_text_down">
                      <img class="mr-1 stats_icon" src="@/assets/manager/down_tick_icon.png" />
                      Down {{ parseInt(previousWeekRepCount - currentWeekRepCount)}} this week</span>
                    <span v-else class="small px-2 py-1">&nbsp;</span>

                  </div>                  
                </div>
                <div class="col pl-xl-4 pl-lg-2 pr-0" style="cursor: pointer;" @click="competencyReport()">
                  <div class="shadow p-3 information_box">
                    <div class="information_box_title">Competencies</div>
                    <div class="h3">{{ currentWeekCompetencyCount }}</div>

                    <span v-if="(previousWeekCompetencyCount < currentWeekCompetencyCount)" class="small px-2 py-1 information_box_text_up">
                      <img class="mr-1 stats_icon" src="@/assets/manager/up_tick_icon.png" />
                      Up {{ parseInt(currentWeekCompetencyCount - previousWeekCompetencyCount)}} this week</span>
                    <span v-else-if="(previousWeekCompetencyCount > currentWeekCompetencyCount)" class="small px-2 py-1 information_box_text_down">
                      <img class="mr-1 stats_icon" src="@/assets/manager/down_tick_icon.png" />
                      Down {{ parseInt(previousWeekCompetencyCount - currentWeekCompetencyCount)}} this week</span>
                    <span v-else class="small px-2 py-1">&nbsp;</span>

                  </div>                  
                </div>
              </div>

              <div class="row mt-5 rounded-lg shadow" v-if="(checklistLoading == false && mentorCount == 0)">
                <div class="col py-3">                
                  <div class="h6 mb-3 font-weight-bold text-center">Step 1</div>
                  <div class="text-center">
                    <a href="#" class="btn btn-info btn-md text-white font-weight-bold rounded-pill px-3" @click.prevent="openAddMentorModal('mentor')">Add Mentors</a>
                  </div>
                </div>
              </div>

              <div class="row mt-5 rounded-lg shadow" v-if="(checklistLoading == false && menteeCount == 0)">
                <div class="col py-3">                
                  <div class="h6 mb-3 font-weight-bold text-center">Step 2</div>
                  <div class="text-center">
                    <a href="#" class="btn btn-info btn-md text-white font-weight-bold rounded-pill px-3" @click.prevent="openAddMenteeModal()">Add Mentees</a>
                  </div>
                </div>
              </div>

              <DashboardMenteesList 
                v-if="menteeCount > 0"
                @openRepToReviewModal="openRepToReviewModal"
                ref="DashboardMenteesList"
              ></DashboardMenteesList>

            </div>
            <div class="col-5 pl-4 pl-xl-4 pr-3 pr-xl-5 mb-5">              
              <div v-if="(checklistLoading == false && checklistCompleteFlag == 0)">
              <ManagerChecklist
                ref="ManagerChecklist"
                
                @openAddMentorModal="openAddMentorModal"
              ></ManagerChecklist>
              </div>



            <div class="col-12 mb-3 p-0" >
              <div class="shadow rounded px-2 py-1">
                <div class="h4 mt-1 mb-1">Reports</div>

                <div class="row justify-content-center mb-3">

                  <router-link :to="{ name: 'pathwayprogressreports' }" class="text-muted">
                  <div class="report-panel rounded text-center p-1 text-muted" style="border-color: #002F42 !important">
                      <img class="" src="@/assets/manager/Mentor Mentee Progress Report Icon.png" style="width: 25px; margin-top: 5px; margin-bottom: 5px;" />
                      <p class="mb-0 small" style="color: #002F42;">Progress</p>
                  </div>
                  </router-link>

                  <router-link :to="{ name: 'competencyreport' }" class="text-muted">
                  <div class="report-panel rounded text-center p-1 text-muted" style="border-color: #002F42 !important">
                      <img class="" src="@/assets/manager/competency_report_icon.png" style="width: 19px; margin-top: 5px; margin-bottom: 5px;" />
                      <p class="mb-0 small"  style="color: #002F42;">Competency</p>
                  </div>
                  </router-link>

                  <router-link :to="{ name: 'managerUsageReports' }" class="text-muted">
                  <div class="report-panel rounded text-center p-1 text-muted" style="border-color: #002F42 !important; margin-right: 0px !important;">
                      <img class="" src="@/assets/manager/usage_report_icon.png" style="width: 25px; margin-top: 5px; margin-bottom: 8px;" />
                      <p class="mb-0 small"  style="color: #002F42;">Usage</p>

                  </div>
                  </router-link>

                  <router-link :to="{ name: 'repaudittrail' }" class="text-muted">
                  <div class="report-panel rounded text-center p-1 text-muted" style="border-color: #002F42 !important;">
                      <img class="" src="@/assets/manager/tasks_icon_rep_audit_trail.png" style="width: 22px; margin-top: 5px; margin-bottom: 10px;" />
                      <p class="mb-0 small"  style="color: #002F42;">Tasks</p>
                  </div>
                  </router-link>


                </div>
              </div>
            </div>

            <div class="col-12 p-0" style="padding-top: 22px !important;">
              <DashboardNotifications></DashboardNotifications>
            </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <MenteeRepsToReview 
      :isReptoReviewModalVisible="isReptoReviewModalVisible" 
      @close="closeRepToReviewModal"
      @closeRepToReviewModal="closeRepToReviewModal"
      @reduceRepCount="reduceRepCount"
      ref="MenteeRepsToReview">
    </MenteeRepsToReview>

    <!-- Bell icon to see the introduction slide -->
    <div class="fixed-bell-icon btn btn-primary d-none-" @click="showIntroductionSlide" v-if="introduction_slide_obj.length > 0">
       <i class="fa fa-bell" aria-hidden="true"></i>       
    </div>

    <ProcessPaymentModal :isModalVisible="isProcessPaymentModalVisible" @close="isProcessPaymentModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading process-payment-modal" style="margin-left: 5px; background-color: #18374A; "><h3 style=" color: #FFF !important; padding: 10px 20px 6px 20px; border-radius: 0 !important;">Invoice Due</h3></div>
      <div slot="body" class="send-assessment-content">
        <div class="col-12 p-0">
          <div class="col-7 p-0 float-left">
            <div class="process-text bold">{{ ppAccountName }}</div>
            <div class="process-text">{{ ppPrimaryName }}</div>
            <div class="process-text">{{ ppAddress }}</div>
            <div v-if="ppState" class="process-text">{{ ppCity }}, {{ ppState }} {{ ppZip }}</div>
            <div v-else class="process-text">{{ ppCity }} {{ ppZip }}</div>
            <div class="process-text bold" style="margin-top: 10px;">Number of Licenses:</div>
            <div class="process-text">{{ ppLicenseCount }}x Mentee License</div>
            <div class="process-text bold" style="margin-top: 10px;">Total Dues:</div>
            <div class="process-text"><span class="dollarsign" >$</span> {{ppDueAmount}}</div>
          </div>
          <div class="col-5 p-0 float-left">
            <div class="process-text bold" style="margin-top: 0px;">Invoice Date:</div>
            <div class="process-text">{{ ppInvoiceDate }}</div>
            <div class="process-text bold" style="margin-top: 10px;">Due Date:</div>
            <div class="process-text">{{ ppDueDate }}</div>
            <div class="process-text bold" style="margin-top: 10px;">Invoice No:</div>
            <div class="process-text">{{ ppInvoiceNo }}</div>
          </div>
          <div style="clear: both;"></div>
          <div class="col-12 p-0" style="margin-top: 5px;">
            <div class="col-6 p-0 float-left" style="text-align: right; padding-right: 10px !important;">
              <button type="submit" class="btn btn-md ma-blue-btn" @click="getInvoicePdf()">View Invoice</button>
            </div>
            <div class="col-6 p-0 float-left" style=" padding-left: 10px !important;">
              <button type="submit" class="btn btn-md ma-blue-btn" style="width: 150px;" @click="processPayment(ppOrderId)">Process Payment</button>
            </div>
          </div>
          <div style="clear: both;"></div>

        </div>
      </div>
      <div slot="footer" class="col-3 p-0 text-align-right" >
        <div style="padding-right: 20px; cursor: pointer;" @click="isProcessPaymentModalVisible = false">Close</div>
      </div>
    </ProcessPaymentModal>

    <IntroductionModal
      :isIntroductionModalVisible="isIntroductionModalVisible"
      :introductionSlideObj="introduction_slide_obj"
      :showSlideNumbers="showSlideNumbers"
      ref="introduction_modal"
      @goToAssessmentLanding="goToAssessmentLanding"
      @close="isIntroductionModalVisible = false">
    </IntroductionModal>

    <MenteeAssessmentLandingPage 
      :isModalVisible="isAssessmentLandingVisible"
      @closeAssessmentLandingModal="closeAssessmentLandingModal"
      @openAssessmentQuestionModal="openAssessmentQuestionModal"
      ref="MenteeAssessmentLandingModal">
    </MenteeAssessmentLandingPage>

    <MenteeAssessmentQuestionPage 
      :isModalVisible="isAssessmentQuestionVisible"
      @closeAssessmentQuestionModal="closeAssessmentQuestionModal"
      ref="MenteeAssessmentQuestionModal">
    </MenteeAssessmentQuestionPage>

    <AccountRepsToReview 
      :isReptoReviewModalVisible="isAccountReptoReviewModalVisible" 
      @close="closeAccountRepToReviewModal"
      @closeAccountRepToReviewModal="closeAccountRepToReviewModal"
      ref="AccountRepsToReview">
    </AccountRepsToReview>

    <AdminconsoleOverlaySidebar
      :isAdminOverlayVisible="isAdminOverlayVisible" 
      @close="closeSidebar"
      ref="admin_overlay_sidebar"               
      :modalFormToLoad="modalFormToLoad" />



  </div>  
</template>

<script>
// import $ from 'jquery';
// import 'bootstrap/js/dist/modal.js';
import axios from 'axios'
import { store } from '../../store/store';
import router from '../../router/index.js';
import UserMenu from '../shared/user_menu.vue';
import IntroductionModal from './introductionManagerTemplateModal.vue';
import ProcessPaymentModal from './invoice_due_modal.vue';
import ManagerSidebarMenu from '@/components/shared/manager_sidebar_menu.vue';
import DashboardNotifications from '@/components/manager/dashboard_notifications.vue';
import DashboardMenteesList from '@/components/manager/dashboard_mentees_list.vue';
import MenteeRepsToReview from '@/components/manager/mentee_reps_to_review.vue';
import AccountRepsToReview from '@/components/manager/account_reps_to_review.vue';
import MenteeAssessmentLandingPage from '@/components/mentee/mentee_assessment_landing_new.vue';
import MenteeAssessmentQuestionPage from '@/components/mentee/mentee_assessment_question_new.vue';
import ManagerChecklist from '@/components/manager/checklist.vue';
import AdminconsoleOverlaySidebar from './adminconsole_overlay_sidebar.vue';


const today = new Date();
today.setHours(0, 0, 0, 0);

export default {
  data: function () {
    return {
      loading: false,
      accountName: '',
      introduction_slide_obj: [],
      isIntroductionModalVisible: false,
      showSlideNumbers: false,
      menteeCount: '',
      previousYearMenteeCount: '',
      currentYearMenteeCount: '',
      repsReviewCount: '',
      previousWeekRepCount: '',
      currentWeekRepCount: '',
      competencyEarnedCount: '',
      previousWeekCompetencyCount: '',
      currentWeekCompetencyCount: '',
      isProcessPaymentModalVisible: false,
      ppAccountName: '',
      ppPrimaryName: '',
      ppAddress: '',
      ppCity: '',
      ppState: '',
      ppZip: '',
      ppLicenseCount: '',
      ppDueAmount: 0,
      ppInvoiceDate: '',
      ppDueDate: '',
      ppInvoiceNo: '',
      ppOrderId: '',
      ppOrderBillingDetails: [],
      isReptoReviewModalVisible: false,
      isAssessmentLandingVisible: false,
      isAssessmentQuestionVisible: false,
      isAccountReptoReviewModalVisible: false,
      mentorCount: '',
      pathwaysCount: '',
      isAdminOverlayVisible: false,
      modalFormToLoad: 'add_mentee',
      checklistCompleteFlag: 1,
      checklistLoading: false,
      menteeCountLoading: false,
    }
  },
  methods: {
    closeSidebar() {
       this.isAdminOverlayVisible = false;            
       this.$refs.admin_overlay_sidebar.resetAddMentorForm();
    },
    openAddMentorModal(type) {
      this.isAdminOverlayVisible = true;

      if (type == 'mentor') {
        this.modalFormToLoad = 'add_mentor';
      } else {
        this.modalFormToLoad = 'add_manager';
      }      
      this.$refs.admin_overlay_sidebar.setupForm(type);
    },
    openAddMenteeModal() {
      this.modalFormToLoad = 'add_mentee';
      this.isAdminOverlayVisible = true;      
      this.$refs.admin_overlay_sidebar.preLoadFormData();
    },
    openAccountRepToReviewModal() {
      this.isAccountReptoReviewModalVisible = true;
      this.$refs.AccountRepsToReview.getMenteeData();
    },
    closeAccountRepToReviewModal() {
      this.isAccountReptoReviewModalVisible = false;
    },
    adminPageRedirect() {
      router.push("/admin-console");
    },
    competencyReport() {
      router.push("/competency-report");
    },
    goToAssessmentLanding(assessmentId, assessmentAttemptId) {
      this.$refs.MenteeAssessmentLandingModal.getLandingPageContent(assessmentId, assessmentAttemptId);
      this.isAssessmentLandingVisible = true;
    },
    closeAssessmentLandingModal() {
      this.isAssessmentLandingVisible = false;
    },
    openAssessmentQuestionModal(assessmentId, assessmentAttemptId) {
      this.$refs.MenteeAssessmentQuestionModal.getScaleLists(assessmentId, assessmentAttemptId);
      this.isAssessmentLandingVisible = false;
      this.isAssessmentQuestionVisible = true;
    },
    closeAssessmentQuestionModal () {
      this.isAssessmentQuestionVisible = false;
    },
    openRepToReviewModal(menteeId) {
      this.isReptoReviewModalVisible = true;
      this.$refs.MenteeRepsToReview.getMenteeData(menteeId);
    },
    closeRepToReviewModal() {
      this.isReptoReviewModalVisible = false;
    },
    reduceRepCount(data) {
      this.$refs.DashboardMenteesList.reduceRepCount(data);
    },
    showIntroductionSlide() {
      this.$refs.introduction_modal.getDefaultSlide();
      this.isIntroductionModalVisible = true;      
    },
    processPayment: function(orderId) {
      this.$store.dispatch('invoice_due_order_id', orderId);
      this.isProcessPaymentModalVisible = false;
      router.push("/admin-console");
    },
    getAccountStatistics () {
      this.menteeCountLoading = true;
      axios.get('/desktop/v2/account-statistics', {
        params: {
          account_id: this.$store.state.user_accountid,
        }
      })
      .then(response =>  {
        this.menteeCountLoading = false;
        this.menteeCount = response.data.menteeCount;
        this.previousYearMenteeCount = response.data.previousYearMenteeCount;
        this.currentYearMenteeCount = response.data.currentYearMenteeCount;
        this.repsReviewCount = response.data.repsReviewCount;
        this.previousWeekRepCount = response.data.previousWeekRepCount;
        this.currentWeekRepCount = response.data.currentWeekRepCount;
        this.competencyEarnedCount = response.data.competencyEarnedCount;
        this.previousWeekCompetencyCount = response.data.previousWeekCompetencyCount;
        this.currentWeekCompetencyCount = response.data.currentWeekCompetencyCount;
        this.mentorCount = response.data.mentorCount;
        this.checklistCompleteFlag = response.data.checklistCompleteFlag;

        if (this.checklistCompleteFlag == 0) {
          this.checklistLoading = false;
          setTimeout(() => {
          this.$refs.ManagerChecklist.setUpData();
          }, 1000);
        }
      })
      .catch(function() {
        
      });
    },
    getInvoicePdf() {
      let pdfEndPoint;
      pdfEndPoint = '/getOrderInvoicePdf';
      axios(pdfEndPoint,
      {
        method: 'POST',
        data: {
            "billing": {
                "billing_name": this.ppOrderBillingDetails.billingName,
                "billing_address": this.ppOrderBillingDetails.billingAddress,
                "billing_address2": this.ppOrderBillingDetails.billingAddress2,
                "billing_city": this.ppOrderBillingDetails.billingCity,
                "billing_country": this.ppOrderBillingDetails.billingCountry,
                "billing_phone": this.ppOrderBillingDetails.billingPhone,
                "billing_state": this.ppOrderBillingDetails.billingState,
                "billing_zip": this.ppOrderBillingDetails.billingZip,
                "billing_primary_admin": this.ppPrimaryName,
            },
            "orderId": this.ppOrderId
        }
        },
      )
      .then(response => {
        window.open(response.data.invoice_filepath, '_blank');
      })
      .catch(error => {
        console.log(error)
      });
    },
  },

  created() {
    this.checklistLoading = true;
    this.menteeCountLoading = true;
    this.accountName = this.$store.state.user_locations.locations.find(loc => loc.accId === this.$store.state.user_accountid).accountName;

    var roles = store.state.roles;
    if((roles.indexOf('ROLE_ADMIN') > -1) || (this.$store.state.switch_admin_username)) {
      this.admin = true;
    }

    var flag = 0;
    if((!this.$store.state.invoice_due_modal_date) || (this.$store.state.invoice_due_modal_date < today)) {
      flag = 1;
    }

    axios.get('/get-dashboard-introduction-slide', {
      params: {
        user_roles: 'ROLE_ADMIN',
        accountId: this.$store.state.user_accountid,
      }
    })
    .then(response =>  {
      this.introduction_slide_obj = response.data.introduction_slide;
      this.showSlideNumbers = response.data.showSlideNumbers;
      if(this.introduction_slide_obj.length > 0) {
        if(this.$store.state.introduction_template_display == 1) {
          setTimeout(() => {
            this.$refs.introduction_modal.getDefaultSlide();
            this.isIntroductionModalVisible = true;
            this.$store.dispatch('introduction_template_display', 0);
          }, 1000);
        }
      }
    })
    .catch(function() {
      
    });

    if((flag == 1) && (((roles.indexOf('ROLE_BILLING_ADMIN') > -1) || (roles.indexOf('ROLE_PRIMARY_ADMIN') > -1)))) {
      axios.get('/get-last-process-payment-order-details', {})
        .then(response =>  {
          this.ppAccountName = response.data.account_name;
          this.ppPrimaryName = response.data.account_primary_admin;
          this.ppAddress = response.data.account_address;
          this.ppCity = response.data.account_city;
          this.ppState = response.data.account_state;
          this.ppZip = response.data.account_zip;
          this.ppInvoiceNo = response.data.invoice;
          this.ppDueAmount = response.data.price;
          this.ppOrderId = response.data.order_id;
          if(this.ppOrderId) {
            this.isProcessPaymentModalVisible = true;
            this.$store.dispatch('invoice_due_modal_date', today);
          }
          this.ppLicenseCount = response.data.license_count;
          this.ppInvoiceDate = response.data.invoice_date;
          this.ppDueDate = response.data.due_date;
          this.ppOrderBillingDetails = response.data.billing_info;
        })
        .catch(function() {});
      }
      this.getAccountStatistics();
  },

  components: {
    UserMenu,
    IntroductionModal,
    ProcessPaymentModal,
    ManagerSidebarMenu,
    DashboardNotifications,
    DashboardMenteesList,
    MenteeRepsToReview,
    MenteeAssessmentLandingPage,
    MenteeAssessmentQuestionPage,
    AccountRepsToReview,
    ManagerChecklist,
    AdminconsoleOverlaySidebar,
  },
  beforeRouteLeave(to, from, next) {
    // $('#rightPanelModal').modal('hide');
    next();
  },
}
</script>

<style>
@import '../../assets/styles/style_v2.css';
</style>

<style scoped>
.information_box_title {
  font-size: 1.25rem !important;
}
@media (max-width: 1199.98px) {
  .information_box_title {
    font-size: 1rem !important;
  }
}
.fixed-bell-icon {
    position: fixed;
    right: 15px;
    bottom: 30px;
    border-radius: 50%;
    box-shadow: 1px 1px 11px 1px #a59a9a;
    font-size:25px;
    background-color: #29A3E4 !important;
    border-color: #29A3E4 !important; 
    cursor: pointer;
}
.content-wrapper {
  padding-top: 75px;
}
.container-wrapper .heading {
  font-size: 28px;
  font-weight: normal;
}
.information_box_text_up {
  border-radius: 5px;
  background-color: #D8F2FC;
}

.information_box_text_up i {
  color: #4DB1D8;
  transform: rotate(45deg);
}
.information_box_text_down {
  border-radius: 5px;
  background-color: #FBD9CC;

}
.information_box_text_down i {
  color: #F16733;
  transform: rotate(315deg);
}

@media (max-width: 1199.98px) {
  .information_box_text_up, .information_box_text_down {
    font-size: .65rem !important;
  }
}
input:focus, select:focus, textarea:focus, button:focus {
  border-color: #ced4da;
}
a {
  color: #00acee;
}
a:hover,
a:active,
a:focus {
  color: #00acee;
}
.modal-header .sub-heading h3 {
  color: #002F42;
  font-size: 15px;
  font-weight: 900;
}
.ma-blue-btn {
  color: #FFF !important; 
  border-radius: 10px;
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  font-weight: 900;
  width: 130px;
  padding: 4px;
}
.stats_icon {
  width: 8px !important;
}
@media (max-width: 1366px) {
  .report-panel {
    width: 95px;
  }
}
@media (min-width: 1367px) {
  .report-panel {
    width: 112px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/manager/manager_dashboard.vue